<template>
  <div>
    <el-form :inline="true" :model="query" @keyup.enter.native="load">
      <el-form-item label="会计年度">
        <el-select v-model="query.year" size="small" style="width:100px" @change="onYearChange">
          <el-option v-for="y in years" :key="y" :label="y" :value="y" />
        </el-select>
      </el-form-item>
      <el-form-item label="期号">
        <el-select v-model="query.periodNo" size="small" style="width:80px" @change="load">
          <el-option v-for="n in 12" :key="n" :label="n" :value="n" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:balanceSheet:list')" type="primary" size="small" @click="load">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle" :row-class-name="rowClassName">
      <el-table-column prop="sectionName" label="报表项目" width="100" />
      <el-table-column prop="subjectCode" label="科目编码" width="140" />
      <el-table-column prop="subjectName" label="科目名称" min-width="180" />
      <el-table-column prop="amount" label="金额" width="140" align="right"><template slot-scope="s">{{ money(s.row.amount) }}</template></el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '../../api/request'
import auth from './financeAuth'
import periodQuery from './financePeriodQuery'

export default {
  mixins: [auth, periodQuery],
  data() { return { list: [] } },
  created() { this.loadLedgerYears(true) },
  methods: {
    rowClassName({ row }) {
      if (row.rowType === 'difference' && Number(row.amount) !== 0) return 'balance-difference-row'
      return row.rowType === 'total' || row.rowType === 'difference' ? 'balance-total-row' : ''
    },
    load() {
      if (!this.query.year || !this.query.periodNo) { this.$message.warning('请选择会计年度和期号'); return }
      this.loading = true
      request.get('/finance/balanceSheet/list', { params: this.periodParams() })
        .then(res => { this.list = res.data || [] })
        .finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
::v-deep .balance-total-row { font-weight: 600; background: #f5f7fa; }
::v-deep .balance-difference-row { font-weight: 600; background: #fef0f0; color: #c45656; }
</style>
